export default __webpack_public_path__ + "static/media/mothGreen.f355e05c.png";